const items = [
  "Imbarco Immediato",
  "Destinazione: Per Sempre",
  "22 Maggio 2027",
  "Villa Grazioli",
  "Castelli Romani",
  "Due Vite, Un Solo Viaggio",
];

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-sand bg-parchment py-4"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((text, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-[11px] uppercase tracking-[0.3em] text-[#5C564E]"
              >
                <span className="px-6">{text}</span>
                <span className="text-terracotta text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
